import { Component, Input, NgZone, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import Enumerable from 'linq';
import { BasicEventViewModel, CourseEventViewModel, ModifyRegistrationViewModel, PackageAddonViewModel, RegistrationPackageViewModel, UserPackagePurchaseViewModel } from 'src/app/_models/generatedModels';
import { ConferenceCMSService, EventService, OrganizationService, UserService } from 'src/app/_services/generatedServices';
import { ToasterService } from 'src/app/_services/toaster.service';
import { log } from "@opentok/client";
declare var fbq: any;
declare var gtag: any;
declare var ga: any;
@Component({
  selector: 'bxl-modify-registration',
  templateUrl: 'modify-registration.component.html',
})
export class ModifyRegistrationComponent implements OnInit {
  initialized = false;
  // @Input() existingRegistration: UserPackagePurchaseViewModel;
  // @Input() conferenceId: number;
  submitComplete: Promise<{}> | undefined;

  actualPrice = 0;
  public cardNumber: string;
  public expMo: string;
  public expYr: string;
  public cvv: string;
  errorMessage: string;
  addons: PackageAddonViewModel[];
  eventAddons: CourseEventViewModel[];
  purchasedAddons: PackageAddonViewModel[];
  purchasedEventAddons: CourseEventViewModel[];
  model: ModifyRegistrationViewModel;
  @ViewChild('theForm', { static: false }) public userFrm: NgForm;
  startTimes: Enumerable.IGrouping<any, unknown>[];
  reservedBreakouts: number[];
  existingRegistration: UserPackagePurchaseViewModel;

  constructor(public activeModal: NgbActiveModal, private router: Router, private userService: UserService, private route: ActivatedRoute, private orgService: OrganizationService, private cmsService: ConferenceCMSService, private eventService: EventService, private zone: NgZone, private toaster: ToasterService) {}

  ngOnInit(): void {
    this.route.paramMap.subscribe((params) => {
      var packageId = +params.get('packageId');
      var conferenceSlug = params.get('conferenceSlug');

      console.log(packageId);

      this.userService.hasRegisteredForConference(conferenceSlug).subscribe((existingRegistration) => {
        this.existingRegistration = existingRegistration;

        if (existingRegistration == null) {
          this.initialized = true;
          return;
        }
        this.cmsService.getSingleRegistrationPackage(conferenceSlug, existingRegistration.packageId).subscribe((pckg) => {
          if (pckg.reserveBreakouts) {
            this.startTimes = Enumerable.from(pckg.courseEvents)
              .where((x) => x.currentBreakoutCount < x.breakoutCapacity || existingRegistration.reservations.findIndex((r) => r.courseEventId == x.id) >= 0)
              .orderBy((x) => x.startTime)
              .groupBy((x) => x.formattedFullTime)
              .where((x) => x.getSource().length > 1)
              .toArray();
            console.log(this.startTimes[0]);

            this.reservedBreakouts = new Array<number>(this.startTimes.length);

            for (var i = 0; i < this.startTimes.length; i++) {
              for (var j = 0; j < this.existingRegistration.reservations.length; j++) {
                var item: BasicEventViewModel[] = <BasicEventViewModel[]>(<unknown>this.startTimes[i].getSource());
                var ids = Enumerable.from(item)
                  .select((x) => x.id)
                  .toArray();

                if (ids.indexOf(this.existingRegistration.reservations[j].courseEventId) > -1) {
                  this.reservedBreakouts[i] = this.existingRegistration.reservations[j].courseEventId;
                }
              }
            }
          }

          this.model = new ModifyRegistrationViewModel();
          var addons = Enumerable.from(pckg.addOns);
          var purchasedAddons = Enumerable.from(this.existingRegistration.addOns).select((x) => x.addOnId);

          this.addons = addons.where((x) => !purchasedAddons.contains(x.id)).toArray();
          this.purchasedAddons = addons.where((x) => purchasedAddons.contains(x.id)).toArray();

          this.eventAddons = Enumerable.from(this.existingRegistration.package.eventAddons)
            .where((x) => !x.userHasPurchased)
            .toArray();
          this.purchasedEventAddons = Enumerable.from(this.existingRegistration.package.eventAddons)
            .where((x) => x.userHasPurchased)
            .toArray();

          this.initialized = true;
        });
      });
    });
  }

  purchasePackageClicked() {
    if (!this.userFrm.valid) {
      this.markAllTouched();
      this.errorMessage = 'There are some invalid or missing fields. Please fill out all required fields.';
      return;
    }

    this.errorMessage = '';

    this.model.selectedAddOns = Enumerable.from(this.addons)
      .where((x) => x.selected)
      .toArray();

    this.model.selectedEventAddons = Enumerable.from(this.eventAddons)
      .where((x) => x.selected)
      .toArray();

    this.model.reservedBreakouts = this.reservedBreakouts;

    this.submitComplete = new Promise((resetButton: any, reject) => {
      this.purchasePackage(resetButton);
    });
  }

  purchasePackage(resetButton) {
    if (this.actualPrice == 0) {
      this.purchasePackageFree(resetButton);
      return;
    }

    let card = { number: this.cardNumber, exp_month: this.expMo, exp_year: this.expYr, cvc: this.cvv };
    (<any>window).Stripe.card.createToken(card, (status: number, response: any) => {
      if (status === 200) {
        this.model.cardToken = response.id;

        this.zone.run(() => {
          this.eventService.updatePackage(this.existingRegistration.packageId, this.model).subscribe(
            (result) => {
              if (!result) {
                resetButton();
                this.errorMessage = 'Unable to process transaction';
                return;
              }

              resetButton();
              this.activeModal.close();
              fbq('track', 'Purchase', { value: this.actualPrice, currency: 'USD' });
              gtag('event', 'conversion', {
                event_category: 'purchase',
                event_label: 'package',
                value: this.actualPrice,
              });
              gtag('event', 'conversion', {
                send_to: 'AW-10797976216/1tMrCOP-ov8CEJiV8Jwo',
                value: this.actualPrice,
                currency: 'USD',
                transaction_id: '',
              });
              console.log('here');
              this.router.navigate(['../confirmation'], { relativeTo: this.route });
            },
            (error) => {
              resetButton();
              this.errorMessage = error.error[0];
            }
          );
        });
      } else {
        resetButton();
        this.errorMessage = response.error.message;
      }
    });
  }
  purchasePackageFree(resetButton: any) {
    this.eventService.updatePackage(this.existingRegistration.packageId, this.model).subscribe(
      (result) => {
        if (!result) {
          resetButton();
          this.errorMessage = 'Unable to process transaction';
          return;
        }

        resetButton();
        this.activeModal.close();
        fbq('track', 'Purchase', { value: this.actualPrice, currency: 'USD' });
        gtag('event', 'conversion', {
          event_category: 'purchase',
          event_label: 'package',
          value: this.actualPrice,
        });
        gtag('event', 'conversion', {
          send_to: 'AW-10797976216/1tMrCOP-ov8CEJiV8Jwo',
          value: this.actualPrice,
          currency: 'USD',
          transaction_id: '',
        });
        console.log('here');
        this.router.navigate(['../confirmation'], { relativeTo: this.route });
      },
      (error) => {
        resetButton();
        this.errorMessage = error.error[0];
      }
    );
  }

  markAllTouched() {
    Object.keys(this.userFrm.controls).forEach((field) => {
      // {1}
      const control = this.userFrm.control.get(field);
      console.log(control); // {2}
      control.markAsTouched({ onlySelf: true });
      control.markAsDirty({ onlySelf: true }); // {3}
    });
  }

  calculatePrice() {
    this.actualPrice = 0;

    if (this.model.purchaseCEUs && this.existingRegistration.memberRate && this.existingRegistration.package.memberPricing) {
      this.actualPrice += this.existingRegistration.package.ceuPrice;
    }

    if (this.model.purchaseCEUs && !this.existingRegistration.memberRate && this.existingRegistration.package.memberPricing) {
      this.actualPrice += this.existingRegistration.package.ceuNonMemberPrice;
    }

    if (this.model.purchaseCEUs  && !this.existingRegistration.package.memberPricing) {
      this.actualPrice += this.existingRegistration.package.ceuPrice;
    }

    var addonPrice = Enumerable.from(this.addons)
      .where((x) => x.selected)
      .sum((x) => x.price);
    this.actualPrice += addonPrice;

    var eventAddonPrice = Enumerable.from(this.eventAddons)
      .where((x) => x.selected)
      .sum((x) => (this.existingRegistration.memberRate && x.memberPricing) ? x.memberPrice : x.price);
    this.actualPrice += eventAddonPrice;
  }
}
